import script from "./edit_supplier.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit_supplier.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__